import React, { Component } from 'react'
import { connect }  from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import hoist from 'hoist-non-react-statics'
import Meta from 'components/layout/Meta'
import { InputText, InputPassword, Checkbox } from 'components/forms'
import { required, validateMobile, minAmount, validateBankCard } from 'components/forms/validators'
import MenuButton from 'components/layout/MenuButton'
import { actions } from 'modules'
import classnames from 'classnames'
import { getBizParams, getBanks, getBankCards, rechargeApiPay } from './redux'
import { Modal } from 'react-bootstrap'
import { ErrorDialog } from 'components/dialog/ErrorDialog'
import { authPreload } from 'components/enhancer/preload'
//app level
import Breadcrumb from 'components/layout/Breadcrumb'
import AboutContent from './AboutContent'
import './About.scss'
class About extends Component {
  static title = '账户充值';

  constructor(props) {
    super(props)
  }

  state={
    phoneTip: false,
    showModal: false
  }

  componentDidMount(){
    let { router, user } = this.props
    // System.import('https://code.jquery.com/jquery.js')
    // .then(function() {
    //   debugger
    //   console.log('Loaded!')
    // })
  }

  render() {
    return (
      <div>
        {/* <Breadcrumb breadcrumbs={this.state.breadcrumbs} />
        <div className="wrap product_Detail" id="page_Detail">
          <div className="mg-auto area clearfix">
            <LeftNavigation title={this.state.title} menuList={menuList}/>
            <div className='right'>{this.props.child}</div>
          </div>
        </div>
        <AboutContent child={this.props.children}/> */}
        {this.props.children}
      </div>
    )
  }
}
export default About



// WEBPACK FOOTER //
// ./modules/aboutUs/About.js